import yup from '../../utils/yup';
import createTypedAction from '../createTypedAction';

export const PREFIX = '@@fox/dashboard/';

export const { fetchClients, FETCH_CLIENTS }: any = createTypedAction(
  `${PREFIX}FETCH_CLIENTS`,
);

export const { fetchClientsSuccess, FETCH_CLIENTS_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_CLIENTS_SUCCESS`,
  ['clients', yup.immutable().list().required()]
);

export const { fetchClientsFailed, FETCH_CLIENTS_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_CLIENTS_FAILED`,
  ['err', yup.immutable().map().nullable()]
);
export const { fetchClientsForManager, FETCH_CLIENTS_FOR_MANAGER }: any = createTypedAction(
  `${PREFIX}FETCH_CLIENTS_FOR_MANAGER`,
);
export const { fetchClientsForManagerSuccess, FETCH_CLIENTS_FOR_MANAGER_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_CLIENTS_FOR_MANAGER_SUCCESS`,
  ['clientsForManager', yup.immutable().list().required()]
);
export const { fetchClientsForManagerFailed, FETCH_CLIENTS_FOR_MANAGER_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_CLIENTS_FOR_MANAGER_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { fetchTiers, FETCH_TIERS }: any = createTypedAction(
  `${PREFIX}FETCH_TIERS`,
);

export const { fetchTiersSuccess, FETCH_TIERS_SUCCESS }: any = createTypedAction(
  `${PREFIX}FETCH_TIERS_SUCCESS`,
  ['tiers', yup.immutable().list().required()]
);

export const { fetchTiersFailed, FETCH_TIERS_FAILED }: any = createTypedAction(
  `${PREFIX}FETCH_TIERS_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { updateClient, UPDATE_CLIENT }: any = createTypedAction(
  `${PREFIX}UPDATE_CLIENT`,
  ['clientId', yup.string().required()],
  ['clientRec', yup.immutable().map().required()]
);

export const { updateClientSuccess, UPDATE_CLIENT_SUCCESS }: any = createTypedAction(
  `${PREFIX}UPDATE_CLIENT_SUCCESS`,
  ['client', yup.immutable().list().required()]
);

export const { updateClientFailed, UPDATE_CLIENT_FAILED }: any = createTypedAction(
  `${PREFIX}UPDATE_CLIENT_FAILED`,
  ['err', yup.immutable().map().nullable()]
);

export const { createFacility, CREATE_FACILITY }: any = createTypedAction(
  `${PREFIX}CREATE_FACILITY`,
  ['name', yup.string().required()],
  ['vanityUrl', yup.string().required()]
);

export const { createFacilitySuccess, CREATE_FACILITY_SUCCESS }: any = createTypedAction(
  `${PREFIX}CREATE_FACILITY_SUCCESS`,
  ['client', yup.immutable().map().required()]
);

export const { createFacilityFailed, CREATE_FACILITY_FAILED }: any = createTypedAction(
  `${PREFIX}CREATE_FACILITY_FAILED`,
  ['err', yup.immutable().map().nullable()]
);
